import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

const BASE_CLASSES =
  'box-border inline-flex shrink-0 items-center justify-center rounded-full bg-status-new-indicator ring-2 ring-surface-page';

const DOT_CLASSES = `${BASE_CLASSES} size-2`;

const COUNT_CLASSES = `${BASE_CLASSES} size-4 text-body-caption-semibold text-foreground-inverse`;

/**
 * @cabooseInclude
 *
 * Flags something new or unread. Without a `count` it renders as a plain dot;
 * with one it renders the count inside a larger dot.
 *
 * The indicator is visual only, so pair it with text that says what's new:
 *
 * ```html
 * <ui-new-indicator />
 * <ui-new-indicator [count]="unreadCount()" />
 * ```
 */
@Component({
  selector: 'ui-new-indicator',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'hostClass()',
  },
  template: `{{ count() }}`,
})
export class UiNewIndicatorComponent {
  /** A single-digit number to show inside the indicator. Omit for a plain dot. */
  public readonly count = input<number | null>(null);

  protected readonly hostClass = computed(() =>
    this.count() === null ? DOT_CLASSES : COUNT_CLASSES
  );
}
